import { render } from "./AddEditSapg.vue?vue&type=template&id=14f4a761"
import script from "./AddEditSapg.vue?vue&type=script&lang=js"
export * from "./AddEditSapg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__